export default __webpack_public_path__ + "static/media/github.6310f393.svg";